module.exports = __webpack_public_path__ + "static/media/table.bedd60a4.svg";